<template>
  <div class="mini-cart-item">
    <u-i-image-handler
      class="mini-cart-item__image"
      :img-src="productImage"
      img-loading="lazy"
      img-width="30px"
      img-height="30px"
      img-format="avif"
      img-densities="1x 2x" />
    <nuxt-link
      class="mini-cart-item__name"
      :to="product?.uri"
      @click="toggleMiniCart">
      {{ variation ? variation.name : product.name }}<span v-if="isSubscription"> (Subscription)</span>
    </nuxt-link>
    <p v-if="product?.simpleVariations?.length" class="mini-cart-item__variation">
      {{ product?.simpleVariations[0].value }}
    </p>
    <div class="mini-cart-item__price">
      <current-price :current-price="cartItem.total"/>
    </div>
  </div>
</template>

<script lang="ts">
import { useCartStore } from "~/stores/cart";

export default {
  props: {
    cartItem: Object,
  },
  setup() {
    const cartStore = useCartStore();
    
    return { cartStore }
  },
  computed: {
    product () {
      return this.cartItem?.product?.node;
    },
    variation() {
      return this.cartItem?.variation?.node;
    },
    productImage() {
      if (this.variation?.image?.mediaItemUrl) {
        return this.variation.image.mediaItemUrl
      }

      return this.product?.featuredImage?.node?.sourceUrl
    },
    isSubscription() {
      return !! this.cartItem?.subscriptionItemDetails?.duration;
    }
  },
  methods: {
    toggleMiniCart() {
      this.cartStore.toggleMiniCart()
    },
  }
};
</script>

<style lang="scss">
@use "~/common/scss/helpers";
@use "~/common/scss/button";

.mini-cart-item {
  display: grid;
  gap: helpers.px-to-rem(5);
  grid-template: "image name quantity price" auto
                 "image variation quantity price" auto / helpers.px-to-rem(30) 1fr auto;
  font-size: 0.85rem;

  &__image {
    grid-area: image;
    align-self: center;
    justify-self: center;
  }

  &__name {
    @include button.buttonBlackText();
    @include button.buttonTextInline();

    grid-area: name;
    font-weight: 600;
  }

  &__variation {
    grid-area: variation;
  }

  &__quantity {
    grid-area: quantity;
    justify-self: right;
  }

  &__price {
    grid-area: price;
    justify-self: right;
  }
}
</style>
